import React from "react";

import { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import { AnimatedDialog } from "./AnimatedDialog";
import { ButtonPrimary, ButtonSecondary } from "../Buttons/Buttons";

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: React.ReactNode;
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
  maxWidth?: DialogProps["maxWidth"];
}

export default function Modal({
  open,
  onClose,
  title,
  children,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  maxWidth = "xs",
}: ModalProps) {
  return (
    <AnimatedDialog open={open} title={title} onClose={onClose} maxWidth={maxWidth}>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogActions sx={{ px: 3 }}>
        {secondaryLabel && <ButtonSecondary onClick={onSecondary ?? onClose}>{secondaryLabel}</ButtonSecondary>}
        <ButtonPrimary onClick={onPrimary} disabled={primaryDisabled}>
          <strong>{primaryLabel}</strong>
        </ButtonPrimary>
      </DialogActions>
    </AnimatedDialog>
  );
}
